import { formatMoney } from '@betterment/core';
import { Separator } from '@betterment/samba-react';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../../graphql/fragments/activityItem.generated';
import { ActivityItemNode } from '../../../types';
import { ClientName } from '../../ClientName';
import { ActivityDrawerLayout } from '../common/ActivityDrawerLayout';
import { StatusSection } from '../common/StatusSection';

export const Withdrawal: React.FC<{
  item: Extract<ActivityItemNode | ActivityItemFragment, { __typename: 'ActivityItemWithdrawal' }>;
}> = ({ item }) => {
  const { users } = item.subAccount;

  return (
    <ActivityDrawerLayout title="Withdrawal" users={users}>
      <DrawerListRow label="Client" value={<ClientName users={users} />} />
      <Separator />
      <DrawerListRow label="From" value={item.withdrawalSourceAccount?.name} />
      <Separator />
      <DrawerListRow label="To" value={item.withdrawalDestinationAccount?.name ?? ''} />
      <Separator />
      <DrawerListRow label="Amount" value={item.amount ? formatMoney(item.amount) : ''} />
      <Separator />
      <DrawerListRow label="Note" value={item.memo ?? '—'} />
      <Separator />
      <StatusSection statuses={item.statuses} />
    </ActivityDrawerLayout>
  );
};
